<template>
  <b-modal
    id="modal-log-activity"
    hide-header
    hide-footer
    size="lg"
    body-class="p-1"
    @shown="onModalShown"
  >
    <div class="">
      <div class="mb-1">
        <h5 class="font-semibold text-[20px] text-black m-0 p-0">
          Log Activity
        </h5>
        <div class="text-[#A0A0A0] text-[14px] m-0 p-0 mt-1">
          View and filter system activity history
        </div>
      </div>

      <div class="flex justify-between items-center mb-1 mt-1">
        <div class="flex items-center gap-1">
          <span class="text-[#A0A0A0] text-[14px] mr-1">Filter by date</span>

          <date-range-picker
            ref="picker"
            v-model="dateRange"
            :locale-data="locale"
            :ranges="ranges"
            :opens="'right'"
            control-container-class="border-0 m-0 p-0"
            class="m-0 p-0"
          >
            <template v-slot:input="picker">
              <div class="border border-[#ced4da] rounded-md p-[8px] flex items-center gap-1 bg-white cursor-pointer min-w-[150px] justify-between">
                <span class="text-[#495057] text-[14px] m-0 p-0">{{ formatDateRange(dateRange.startDate, dateRange.endDate) }}</span>
              </div>
              <span class="d-none">{{ picker }}</span>
            </template>
          </date-range-picker>

          <b-dropdown
            variant="link"
            toggle-class="p-0 m-0 text-decoration-none shadow-none"
            no-caret
            class=""
          >
            <template #button-content>
              <div class="border border-[#ced4da] rounded-md p-[8px] flex items-center gap-1 bg-white cursor-pointer min-w-[120px] justify-between text-black">
                <span class="text-[#495057] text-[14px] m-0 p-0">Jenis Log</span>
                <b-icon
                  icon="chevron-down"
                  class="text-[#A0A0A0]"
                  font-scale="0.9"
                />
              </div>
            </template>
            <b-dropdown-form class="m-0 custom-orange-checkbox [&_.custom-control-input:checked~.custom-control-label::before]:!bg-[#F97316] [&_.custom-control-input:checked~.custom-control-label::before]:!border-[#F97316]">
              <b-form-checkbox
                v-model="filters.agent"
                class="mb-1 text-[13px] text-black"
              >
                Agent Dibuat
              </b-form-checkbox>
              <b-form-checkbox
                v-model="filters.order"
                class="m-0 text-[13px] text-black"
              >
                Closing Order
              </b-form-checkbox>
            </b-dropdown-form>
          </b-dropdown>

          <div class="w-1 h-3 bg-gray-300 mx-2" />

          <div class="text-[#A0A0A0] p-1">
            <span
              class="text-red-500 cursor-pointer text-[14px] hover:underline"
              @click="resetFilter"
            >Reset</span>
          </div>
        </div>
        <div class="text-[#A0A0A0] text-[14px] m-0 p-0">
          {{ totalRows }} entries
        </div>
      </div>

      <div class="flex flex-col gap-2 mt-1">
        <div
          v-for="(log, idx) in logs"
          :key="'modal-'+idx"
          class="border border-gray-200 rounded-lg p-[8px] flex justify-between items-center bg-white"
        >
          <div class="flex items-center gap-1">
            <img
              :src="log.type === 'agent' ? 'https://storage.googleapis.com/komerce/assets/icons/icons/person-blue.png' : 'https://storage.googleapis.com/komerce/assets/icons/icons/bag-check.png'"
              alt="icon"
            >
            <div class="ml-1">
              <div class="text-black font-medium text-[14px] m-0 p-0 leading-tight">
                {{ log.title }}
              </div>
              <div class="text-[#A0A0A0] text-[12px] m-0 p-0 mt-[6px]">
                Dibuat oleh {{ log.author }}
              </div>
            </div>
          </div>
          <div class="text-right shrink-0 ml-1">
            <div class="text-black text-[13px] m-0 p-0 leading-tight">
              {{ log.date }}
            </div>
            <div class="text-[#A0A0A0] text-[12px] m-0 p-0 mt-1">
              {{ log.time }}
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-end items-center gap-1 mt-1 pt-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="m-0"
        />
      </div>
    </div>
  </b-modal>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {
  LABELDAY,
  LABELMONTH,
  DDMMYYYY,
  TIME,
  YEAR_MONTH_DAY,
} from '@/libs/filterDate'
import {
  today, last7, last30, firstDateOfMonth, lastDateOfLastMonth, lastMonth,
} from '@/store/helpers'
import { apiDataActivity } from '../services/api.komchat.service'

export default {
  name: 'LogActivityModal',
  components: {
    DateRangePicker,
  },
  data() {
    return {
      dateRange: {
        startDate: last30,
        endDate: today,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'Hari Ini': [today, today],
        '7 Hari Terakhir': [last7, today],
        '30 Hari Terakhir': [last30, today],
        'Bulan Ini': [firstDateOfMonth, today],
        'Bulan Kemarin': [lastMonth(1), lastDateOfLastMonth],
        'Custom Range': [today, today],
      },
      filters: {
        agent: false,
        order: false,
      },
      logs: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 5,
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        if (this.currentPage !== 1) {
          this.currentPage = 1
        } else {
          this.fetchLogs()
        }
      },
    },
    dateRange: {
      deep: true,
      handler() {
        if (this.currentPage !== 1) {
          this.currentPage = 1
        } else {
          this.fetchLogs()
        }
      },
    },
    currentPage() {
      this.fetchLogs()
    },
  },
  methods: {
    formatDateRange(start, end) {
      if (!start || !end) return 'Range Date'
      if (YEAR_MONTH_DAY(start) === YEAR_MONTH_DAY(end)) {
        return DDMMYYYY(start)
      }
      return `${DDMMYYYY(start)} - ${DDMMYYYY(end)}`
    },
    resetFilter() {
      this.filters.agent = false
      this.filters.order = false
      this.dateRange = { startDate: last30, endDate: today }
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        this.fetchLogs()
      }
    },
    onModalShown() {
      this.fetchLogs()
    },
    async fetchLogs() {
      const startDate = YEAR_MONTH_DAY(this.dateRange.startDate)
      const endDate = YEAR_MONTH_DAY(this.dateRange.endDate)

      let eventType = ''
      if (this.filters.agent && !this.filters.order) eventType = 'agent'
      else if (!this.filters.agent && this.filters.order) eventType = 'closing'

      // Gunakan offset 1-based (seperti di parameter API) atau 0-based
      const offset = (this.currentPage - 1) * this.perPage

      try {
        const res = await apiDataActivity({
          startDate,
          endDate,
          eventType,
          limit: this.perPage + 1, // Fetch 1 extra to check if there is a next page
          offset,
        })
        if (res && res.data && res.data.data) {
          const { total, details } = res.data.data
          const safeDetails = details || []
          let computedTotal = Number(total) || 0
          // Jika data yang dikembalikan <= perPage, berarti ini adalah halaman TERAKHIR!
          // Kita bisa langsung membetulkan totalRows mengabaikan total salah dari API.
          if (safeDetails.length <= this.perPage) {
            computedTotal = (this.currentPage - 1) * this.perPage + safeDetails.length
          }
          this.totalRows = computedTotal
          // Potong array agar hanya menampilkan sesuai batas perPage (karena kita fetch +1)
          const displayDetails = safeDetails.slice(0, this.perPage)
          this.logs = displayDetails.map(log => {
            const isAgent = log.event_type === 'agent'
            const title = isAgent
              ? `Agent Customer Service ${log.agent_name || ''} Dibuat`
              : log.closing || '-'
            return {
              type: isAgent ? 'agent' : 'order',
              title,
              author: log.partner_name || '-',
              date: DDMMYYYY(log.timestamp),
              time: TIME(log.timestamp),
            }
          })
        } else {
          this.totalRows = 0
          this.logs = []
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch activity logs', err)
      }
    },
  },
}
</script>
